import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueSweetalert2 from "vue-sweetalert2";
import "./assets/css/bootstrap.min.css";
import "./assets/css/icons.min.css";
import "./assets/css/app.min.css";
import "boxicons/css/boxicons.min.css";
import "sweetalert2/dist/sweetalert2.min.css";
import bootstrap from "./assets/libs/bootstrap/js/bootstrap.bundle.min.js";
import contentUploadMixin from "./contentUploadMixin";

// Disponibiliza os componentes interativos usados pelos atributos data-bs-*
// e pelos formulários que fecham modais programaticamente.
window.bootstrap = bootstrap;

const app = createApp(App);
app.mixin(contentUploadMixin);

app.use(router);
app.config.globalProperties.$bus = window;
router.beforeEach((to, from) => {
  if (to.fullPath !== from.fullPath) {
    window.dispatchEvent(new CustomEvent('facturize:navigation-start'));
  }
});
router.afterEach(() => window.dispatchEvent(new CustomEvent('facturize:navigation-end')));
app.use(store);
app.use(VueSweetalert2);
app.mount("#app");
